<template>
  <div class="" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="pay_content" ref="top">
      <!-- 导航栏 -->
      <div
        class="pay_header"
        :class="{ 'show-header': isScrollTop, 'hide-header': !isScrollTop }"
      >
        <div class="pay_header_content">
          <div class="page_header_main">
            <div class="page_header_left">
              <img src="../../assets/logoshop.png" alt="" srcset="" />
            </div>
            <div class="page_header_right" v-if="isLogin">
              <el-dropdown trigger="click">
                <div class="page_header_right_content">
                  <img
                    class="page_header_right_img"
                    src="../../assets/person.png"
                    alt=""
                  />
                  <i class="el-icon-caret-bottom"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <div class="user_info">
                    <div class="user_info_content">
                      <div class="user_info_left">
                        <img src="../../assets/person.png" alt="" />
                      </div>
                      <div class="user_info_right">
                        <div class="user_info_name">
                          {{ formInline.role_name }}
                        </div>
                        <div class="user_info_id">
                          ID:{{ formInline.cp_roleid }}
                        </div>
                      </div>
                    </div>
                    <div class="user_game">
                      <div class="user_game_content">
                        <div class="user_game_left">
                          <img :src="gameInfo.game_icon" alt="" />
                        </div>
                        <div class="user_game_right">
                          {{ gameInfo.game_name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <el-dropdown-item>
                    <div class="user_exit" @click="outLogin">
                      <div class="user_icon">
                        <svg viewBox="0 0 24 24" width="24px" height="24px">
                          <path
                            fill="currentColor"
                            d="M14.945 1.25c-1.367 0-2.47 0-3.337.117c-.9.12-1.658.38-2.26.981c-.524.525-.79 1.17-.929 1.928c-.135.737-.161 1.638-.167 2.72a.75.75 0 0 0 1.5.008c.006-1.093.034-1.868.142-2.457c.105-.566.272-.895.515-1.138c.277-.277.666-.457 1.4-.556c.755-.101 1.756-.103 3.191-.103h1c1.436 0 2.437.002 3.192.103c.734.099 1.122.28 1.4.556c.276.277.456.665.555 1.4c.102.754.103 1.756.103 3.191v8c0 1.435-.001 2.436-.103 3.192c-.099.734-.279 1.122-.556 1.399c-.277.277-.665.457-1.399.556c-.755.101-1.756.103-3.192.103h-1c-1.435 0-2.436-.002-3.192-.103c-.733-.099-1.122-.28-1.399-.556c-.243-.244-.41-.572-.515-1.138c-.108-.589-.136-1.364-.142-2.457a.75.75 0 1 0-1.5.008c.006 1.082.032 1.983.167 2.72c.14.758.405 1.403.93 1.928c.601.602 1.36.86 2.26.982c.866.116 1.969.116 3.336.116h1.11c1.368 0 2.47 0 3.337-.116c.9-.122 1.658-.38 2.26-.982c.602-.602.86-1.36.982-2.26c.116-.867.116-1.97.116-3.337v-8.11c0-1.367 0-2.47-.116-3.337c-.121-.9-.38-1.658-.982-2.26c-.602-.602-1.36-.86-2.26-.981c-.867-.117-1.97-.117-3.337-.117z"
                          ></path>
                          <path
                            fill="currentColor"
                            d="M15 11.25a.75.75 0 0 1 0 1.5H4.027l1.961 1.68a.75.75 0 1 1-.976 1.14l-3.5-3a.75.75 0 0 1 0-1.14l3.5-3a.75.75 0 1 1 .976 1.14l-1.96 1.68z"
                          ></path>
                        </svg>
                      </div>
                      <div>Đăng xuất</div>
                    </div>
                  </el-dropdown-item>
                  <div class="user_logo">
                    <img src="../../assets/vnggames_account_logo.png" alt="" />
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <!-- 移动端bottom -->
      <div class="page_bottom">
        <div class="page_bottom_left">
          <div class="page_bottom_shop" @click="openShopInfo()">
            <div class="page_bottom_shop_icon">
              <svg viewBox="0 0 24 24" width="100%" height="100%" color="#fff">
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M14.665 2.33a.75.75 0 0 1 1.006.335l2.201 4.402c1.353.104 2.202.37 2.75 1.047c.9 1.114.541 2.79-.177 6.143l-.429 2c-.487 2.273-.73 3.409-1.555 4.076c-.825.667-1.987.667-4.311.667h-4.3c-2.324 0-3.486 0-4.31-.667c-.826-.667-1.07-1.803-1.556-4.076l-.429-2c-.718-3.353-1.078-5.029-.177-6.143c.548-.678 1.397-.943 2.75-1.047l2.201-4.402a.75.75 0 0 1 1.342.67l-1.835 3.67C8.319 7 8.846 7 9.422 7h5.156c.576 0 1.103 0 1.586.005l-1.835-3.67a.75.75 0 0 1 .336-1.006M7.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M10 14.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
            <div class="page_bottom_shop_num">
              {{ productData.product_img ? 1 : 0 }}
            </div>
          </div>
          <div class="page_bottom_money">
            <div class="page_bottom_money_top">Tổng tiền:</div>
            <div class="page_bottom_money_bottom">
              {{ productData.need_pay || 0 }} VND
            </div>
          </div>
        </div>
        <div class="page_bottom_right">
          <el-button
            type="danger"
            @click="openConfirmInfo"
            :disabled="!productData.need_pay"
            class="page_bottom_btn"
            >Tiếp tục <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
      </div>
      <!-- 背景图 -->
      <div class="page_bg"></div>
      <!-- 基本信息 -->
      <div class="page_content">
        <div class="page_main">
          <div class="page_title">
            <div class="page_game_avatar">
              <div class="page_game_bg"></div>
              <div class="page_game_avatar_img">
                <img :src="gameInfo.game_icon" alt="" />
              </div>
            </div>
            <div class="page_game_title">{{ gameInfo.game_name }}</div>
          </div>
          <div class="page_container">
            <div class="page_left">
              <div class="page_left_content">
                <div class="page_left_login" ref="login">
                  <div class="page_card" v-if="!isLogin">
                    <div class="page_card_title">
                      <div class="page_card_title_left">
                        1. Chọn phương thức đăng nhập
                      </div>
                      <div
                        class="page_card_title_right"
                        @click="openGameDialog"
                      >
                        Hướng dẫn tìm ID
                      </div>
                    </div>
                    <div class="pay-game-form">
                      <el-form
                        :inline="true"
                        :model="formInline"
                        class="demo-form-inline pay-game-formstyle"
                      >
                        <div>
                          <div class="form-title">Server</div>
                          <el-form-item style="width: 100%">
                            <el-select
                              filterable
                              style="width: 100%"
                              v-model="formInline.server_id"
                              placeholder="Chọn server"
                              @change="handleChange"
                              ref="select"
                              @hook:mounted="cancalReadOnly"
                              @visible-change="cancalReadOnly"
                            >
                              <el-option
                                :label="item.server_name"
                                :value="item.server_id"
                                v-for="item in serverList"
                                :key="item.server_id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="form-right">
                          <div>
                            <div class="form-title">ID nhân vật</div>
                            <el-form-item>
                              <el-input
                                class="form-id"
                                v-model="formInline.cp_roleid"
                                placeholder="Nhập ID nhân vật"
                                @input="handleInput"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div>
                            <div class="form-title"><br /></div>
                            <el-form-item>
                              <el-button
                                type="primary"
                                :disabled="disable"
                                @click="onSubmit"
                                class="form-btn"
                                >Lấy nhân vật</el-button
                              >
                            </el-form-item>
                          </div>
                        </div>
                      </el-form>
                    </div>
                    <div class="pay-game-role" v-if="showRole">
                      <el-form
                        :inline="true"
                        :model="formInline"
                        class="demo-form-inline pay-game-formstyle"
                      >
                        <div>
                          <div class="form-title">Nhân vật</div>
                          <el-form-item style="width: 100%">
                            <el-input
                              style="width: 100%"
                              v-model="formInline.role_name"
                              readonly
                            ></el-input>
                          </el-form-item>
                          <el-form-item style="width: 100%">
                            <el-button
                              type="primary"
                              @click="onSubmitRole"
                              class="form-btn"
                              >Tiếp tục</el-button
                            >
                          </el-form-item>
                        </div>
                      </el-form>
                    </div>
                    <div class="pay-no-data" v-if="noData">
                      <div>
                        <i class="el-icon-warning"></i>
                        <span class="pay-no-data-text"
                          >Không tìm thấy nhân vật nào!</span
                        >
                      </div>
                    </div>
                    <div class="pay-no-data" v-if="tooMuchData">
                      <div>
                        <i class="el-icon-warning"></i>
                        <span class="pay-no-data-text"
                          >Opps. Có vẻ bạn đã thử lại nhiều lần, hãy thử xem lại
                          mã tài khoản hoặc liên hệ với chúng tôi để được hỗ
                          trợ.</span
                        >
                      </div>
                    </div>
                    <div class="login_error" v-if="isLoginError">
                      Bạn cần phải đăng nhập
                    </div>
                  </div>
                  <div class="page_card" v-else>
                    <div class="page_card_title">
                      <div class="page_card_title_left">
                        1. Thông tin nhân vật
                      </div>
                    </div>
                    <div class="page_user_info">
                      <div class="page_user_item">
                        <div class="page_user_top">ID nhân vật:</div>
                        <div class="page_user_bottom">
                          {{ formInline.cp_roleid }}
                        </div>
                      </div>
                      <div class="page_user_item">
                        <div class="page_user_top">Nhân vật:</div>
                        <div class="page_user_bottom">
                          {{ formInline.role_name }}
                        </div>
                      </div>
                      <div class="page_user_item">
                        <div class="page_user_top">Máy chủ:</div>
                        <div class="page_user_bottom">
                          {{ formInline.server_name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="page_left_pay" ref="product">
                  <div class="page_card">
                    <div class="page_card_title">
                      <div class="page_card_title_left">2. Chọn gói</div>
                    </div>
                    <div class="page_pay_content">
                      <div class="page_pay_title">
                        <img src="../../assets/receipt-icon.png" alt="" />
                        <p>Danh sách gói</p>
                      </div>
                      <div class="page_pay_product">
                        <div class="page_pay_list">
                          <div
                            class="page_pay_item"
                            v-for="(item, index) in productList"
                            :key="index"
                          >
                            <div
                              class="page_pay_product_info"
                              @click.stop="handleAdd(item, index)"
                            >
                              <div class="page_pay_top">
                                <div class="product_img">
                                  <img :src="item.product_img" alt="" />
                                </div>
                                <div class="product_dec">
                                  <div class="product_dec_info">
                                    {{ item.product_name }}
                                  </div>
                                </div>
                              </div>
                              <div class="page_pay_bottom">
                                <div class="page_pay_num">
                                  <div class="page_pay_num_left">
                                    <div class="page_pay_num_text">
                                      {{ item.need_pay || 0 }} VND
                                    </div>
                                  </div>
                                  <div class="page_pay_num_right">
                                    <div
                                      class="page_pay_click page_pay_add"
                                      v-if="!item.isCheck"
                                    >
                                      <svg
                                        viewBox="0 0 24 24"
                                        width="24px"
                                        height="24px"
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
                                        ></path>
                                      </svg>
                                    </div>
                                    <div
                                      class="page_pay_click page_pay_check"
                                      v-else
                                    >
                                      <svg
                                        viewBox="0 0 24 24"
                                        width="24px"
                                        height="24px"
                                      >
                                        <path
                                          fill="none"
                                          stroke="currentColor"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="1.5"
                                          d="m5 13l4 4L19 7"
                                        ></path>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="page_right">
              <div
                class="page_card_right"
                :class="{
                  page_card_active: selectedIndex !== null,
                }"
              >
                <div class="page_card_right_title">3. Thông tin đơn hàng</div>
                <div class="page_pay_choose">
                  <div class="page_pay_info">
                    <div
                      class="page_pay_info_list"
                      v-if="productData.product_img"
                    >
                      <div class="page_pay_info_img">
                        <img :src="productData.product_img" alt="" />
                      </div>
                      <div class="page_pay_info_list_text">
                        <div class="page_pay_info_list_top">
                          {{ productData.product_name }}
                        </div>
                        <div class="page_pay_info_list_bottom">
                          {{ productData.need_pay || 0 }} VND
                        </div>
                      </div>
                      <div class="page_pay_info_right">
                        <div class="page_pay_info_right_bg">
                          <div>x1</div>
                        </div>
                      </div>
                    </div>
                    <div class="page_pay_info_noData" v-else>
                      Đơn hàng đang trống
                    </div>
                    <div class="page_pay_choose_pmt">
                      <div class="page_pay_choose_title">
                        <div class="page_pay_choose_title_left">
                          Phương thức thanh toán
                        </div>
                        <!-- <div class="page_pay_choose_title_right">
                          <span>Xem tất cả</span>
                          <svg
                            viewBox="0 0 24 24"
                            width="24px"
                            height="24px"
                            color="#F05C22"
                          >
                            <path
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.5"
                              d="m10 17l5-5l-5-5"
                            ></path>
                          </svg>
                        </div> -->
                      </div>
                      <div class="page_pay_channel">
                        <div class="channel_list">
                          <div
                            v-for="(item, index) in atm"
                            :key="index"
                            class="channel_item"
                            :class="{
                              channel_active: selectedIndex === index,
                              'disabled-item': item.disabled,
                            }"
                            @click="
                              item.disabled ? () => {} : selectItem(index)
                            "
                          >
                            <div class="channel-icon">
                              <span>{{ item.name }}</span>
                            </div>
                            <div v-if="item.disabled" class="channel_disabled">
                              Không khả dụng
                            </div>
                            <input
                              v-else
                              type="radio"
                              :name="item.name"
                              :value="index"
                              v-model="selectedIndex"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="page_pay_choose_pmt">
                      <div class="page_pay_choose_title">
                        <div class="page_pay_choose_title_left">
                          Chi tiết thanh toán
                        </div>
                      </div>
                      <div class="page_pay_detail">
                        <div class="page_pay_detail_left">Tổng tiền:</div>
                        <div class="page_pay_detail_right">
                          {{ productData.need_pay || 0 }} VND
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="page_pay_confirm">
                  <div class="page_pay_confirm_info">
                    <div class="page_pay_confirm_info_left">
                      Tổng thanh toán
                    </div>
                    <div class="page_pay_confirm_info_right">
                      {{ productData.need_pay || 0 }} VND
                    </div>
                  </div>
                  <div class="page_pay_confirm_att">
                    Bằng việc nhấn nút “Thanh toán ngay”, bạn đồng ý rằng giao
                    dịch này không hoàn, không hủy và tuân thủ với
                    <a
                      target="_blank"
                      href="https://privacy.mgol.vn"
                      style="
                        color: rgb(34, 160, 234);
                        text-decoration: underline;
                      "
                      >Chính sách bảo mật</a
                    >
                    của MGOL.
                  </div>
                  <div class="page_pay_confirm_btn">
                    <el-button
                      type="primary"
                      class="page_login_btns"
                      @click="handleConfirm"
                      :disabled="
                        !(productData.need_pay && atmData.name && isLogin)
                      "
                    >
                      Thanh toán ngay
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ShopInfo ref="ShopInfo" />
    <ProductInfo ref="ProductInfo" />
    <ConfirmInfo ref="ConfirmInfo" />
    <GameDialog ref="GameDialog" />
  </div>
</template>

<script>
import _ from "lodash";
import ShopInfo from "./components/ShopInfo.vue";
import ProductInfo from "./components/ProductInfo.vue";
import ConfirmInfo from "./components/ConfirmInfo.vue";
import GameDialog from "../../components/GameDialog.vue";
export default {
  name: "",
  mixins: [],
  components: {
    ShopInfo,
    ProductInfo,
    ConfirmInfo,
    GameDialog,
  },
  props: {},
  data() {
    return {
      isLogin: false,
      isLoginError: false,
      loginSetTimeout: null,
      serverList: [],
      roleList: [],
      disable: true,
      noData: false,
      showRole: false,
      tooMuchData: false,
      gameInfo: {
        game_icon: "",
        game_name: "",
      },
      atm: [],
      productList: [],
      productData: {},
      atmData: {},
      selectedIndex: null,
      fullscreenLoading: false,
      goodsList: [],
      isScrollTop: true,
      formInline: {
        cp_roleid: "",
        server_id: "",
        role_name: "",
        game_id: "",
      },
      rules: {
        id: [
          {
            required: true,
            message: "Thông tin nhân vật không hợp lệ",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.formInline.game_id = this.$route.query.game_id;
    if (!this.$route.query.game_id) {
      this.$router.push("/404");
    }
    let userInfo = localStorage.getItem(this.$route.query.game_id);
    if (userInfo) {
      this.formInline = JSON.parse(userInfo);
      this.disable = false;
      this.isLogin = true;
    }
    this.getDataInfo();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    //获取游戏信息
    getDataInfo() {
      this.fullscreenLoading = true;
      let params = {
        game_id: this.$route.query.game_id,
      };
      this.$http.get("/shop/detail", { params }).then((res) => {
        if (res.code === 200) {
          this.gameInfo = res.data;
          this.serverList = res.data.server;
          this.productList = res.data.product_info;
          this.atm = res.data.atm;
          let userInfo = localStorage.getItem(this.$route.query.game_id);
          if (userInfo) {
            this.formInline = JSON.parse(userInfo);
            this.disable = false;
          }
        } else {
          this.$message.warning(res.msg);
        }
        this.fullscreenLoading = false;
      });
    },
    isLoginErrorMudules() {
      clearTimeout(this.loginSetTimeout);
      this.isLoginError = true;
      this.loginSetTimeout = setTimeout(() => {
        this.isLoginError = false;
      }, 3000);
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isScrollTop = scrollTop === 0;
    },

    scrollToModules(item) {
      let scrollTo = this.$refs[item];
      scrollTo.scrollIntoView({ block: "start", behavior: "smooth" });
    },

    selectItem(index) {
      if (!this.productData.product_img) {
        this.scrollToModules("product");
        return;
      }
      if (!this.isLogin) {
        this.scrollToModules("top");
        this.isLoginErrorMudules();
        this.$message.error("Thông tin nhân vật không hợp lệ");
      }
      this.selectedIndex = index;
      this.atmData = this.atm[this.selectedIndex];
    },
    //打开查看游戏ID弹窗
    openGameDialog() {
      let game_id = this.$route.query.game_id;
      const game_img = {
        124: require("@/assets/show/124.png"), //行侠
        20: require("@/assets/show/20.png"), //皇后
        21: require("@/assets/show/21.png"), //山海
      };
      this.$refs.GameDialog.dialogVisible = true;
      this.$refs.GameDialog.gameImg = game_img[Number(game_id)]
        ? game_img[Number(game_id)]
        : require("@/assets/demo.png");
      console.log(this.$refs.GameDialog.gameImg);
    },
    //打开商品弹窗
    openShopInfo() {
      this.$refs.ShopInfo.show = true;
    },
    //查看商品信息弹窗
    openProductInfo(item, index) {
      this.$refs.ProductInfo.show = true;
      this.$refs.ProductInfo.shopData = item;
      this.$refs.ProductInfo.selectedIndex = index;
    },
    //商品确认弹窗
    openConfirmInfo() {
      if (!this.isLogin) {
        this.scrollToModules("top");
        this.isLoginErrorMudules();
        this.$message.error("Thông tin nhân vật không hợp lệ");
        return;
      }
      this.$refs.ConfirmInfo.show = true;
      this.$refs.ConfirmInfo.selectedIndex = null;
      this.$refs.ConfirmInfo.atmData = {};
      this.$refs.ConfirmInfo.shopData = this.productData;
      this.$refs.ConfirmInfo.atm = JSON.parse(JSON.stringify(this.atm));
    },
    //添加商品到购物车
    handleAdd(data, index) {
      this.productList.forEach((item) => {
        item.isCheck = false;
      });
      if (data.product_id != this.productData.product_id) {
        this.selectedIndex = null;
        this.atmData = {};
      }
      this.productList[index].isCheck = true;
      this.productData = JSON.parse(JSON.stringify(this.productList[index]));
      this.atm.forEach((item) => {
        if (this.productData.need_pay < item.min) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      this.$refs.ShopInfo.shopData = this.productData;
      this.$refs.ConfirmInfo.shopData = this.productData;
    },
    //退出登录
    outLogin() {
      localStorage.removeItem(this.$route.query.game_id);
      this.formInline = {
        cp_roleid: "",
        server_id: "",
        role_name: "",
        game_id: this.$route.query.game_id,
      };
      this.showRole = false;
      this.noData = false;
      this.tooMuchData = false;
      this.isLogin = false;
    },
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    //选择区服
    handleChange(e) {
      console.log(e);
      let { cp_roleid, server_id } = this.formInline;
      if (cp_roleid && server_id) {
        this.disable = false;
      } else {
        this.disable = true;
      }
      this.showRole = false;
      this.noData = false;
      this.tooMuchData = false;
    },
    //查看是否填入id
    handleInput(e) {
      let { cp_roleid, server_id } = this.formInline;
      if (cp_roleid && server_id) {
        this.disable = false;
      } else {
        this.disable = true;
      }
      this.showRole = false;
      this.noData = false;
      this.tooMuchData = false;
    },
    onSubmit() {
      let { cp_roleid, server_id, game_id } = this.formInline;
      this.disable = true;
      let params = {
        cp_roleid,
        server_id,
        game_id,
      };
      this.fullscreenLoading = true;
      this.$http.get("/shop/getRole", { params }).then((res) => {
        //这边掉接口 如果200
        if (res.code === 200) {
          this.showRole = true;
          this.formInline.role_name = res.data.role_name;
          this.formInline.userid = res.data.userid;
          console.log(this.formInline);
        } else if (res.code === 201) {
          this.noData = true;
        } else if (res.code === 202) {
          this.tooMuchData = true;
        } else {
          this.$message.warning(res.msg);
        }
        this.fullscreenLoading = false;
      });
    },
    onSubmitRole() {
      let { cp_roleid, server_id, role_name } = this.formInline;
      if (cp_roleid && server_id && role_name) {
        this.formInline.server_name = this.serverList.find(
          (item) => Number(item.server_id) === Number(server_id)
        ).server_name;
        console.log(this.formInline);
        // localStorage.setItem("userInfo", JSON.stringify(this.formInline));
        localStorage.setItem(
          this.formInline.game_id,
          JSON.stringify(this.formInline)
        );
        localStorage.setItem("game_id", this.formInline.game_id);
        this.isLogin = true;
      } else {
        this.$message.warning("Bạn chưa điền hết thông tin");
      }
    },
    handleConfirm() {
      const { cp_roleid, server_id, game_id, userid } = this.formInline;
      const { product_id } = this.productData;
      const { pay_type } = this.atmData;
      let params = {
        cp_roleid,
        server_id,
        game_id,
        product_id,
        pay_type,
        userid,
      };
      this.fullscreenLoading = true;
      this.$http.get("/shop/pay", { params }).then((res) => {
        //这边掉接口 如果200
        if (res.code === 200) {
          window.location.href = res.data.redirect_url;
        } else {
          this.$message.warning(res.msg);
        }
        this.fullscreenLoading = false;
      });
    },
  },
};
</script>

<style scoped>
@import "./css/pc.scss";
@import "./css/phone.scss";
</style>